import React from "react";
import Routes from "../../Routes";

// COMPONENTS
import ParseHTML from "../../functions/ParseHTML";

// REDUX
import { useSelector } from "react-redux";

let bannerData = {
  imageBanner: null,
  // {
  //   url: "https://placeholder.com/wp-content/uploads/2018/10/placeholder.com-logo4.png",
  //   alt: "Company logo",
  //   bgColor: "#fa9c1e",
  //   padding: ".7rem 0 0 1.2rem",
  //   maxWidth: "50%",
  // },
  textBanner: {
    banner: {
      body: "Alpha Awards - Grand Prix 2020",
      format: "text",
    },
    bg: {
      color: "#213148",
      image: null,
    },
    text: {
      color: "#c9af6b",
    },
    logo: {
      alt: "alpha awards GP 2020 Logo",
      href: "//grandprix.alpha-awards.com",
      src: "//minio.staging.alpha-awards.com/public/aagp20/Logo_aaGP.jpg",
      title: "alpha awards GRAND PRIX 2020",
    },
    subtitle: {
      body: "Subtitle text here",
      format: "html",
    },
  },
};

const CompanyBanner = () => {
  const activeModule = useSelector(state => state.user.role_selected);
  const banner = useSelector(
    state => state.app.info.apps[state.app.info.default_app].modules[activeModule].banner
  );

  const renderImageBanner = data => (
    <div
      className="__x __x_io"
      style={{
        background: data.bgColor || "#4e4e4e",
      }}
    >
      <img
        src={data.url}
        alt={data.alt}
        style={{
          padding: data.padding || "",
          width: data.maxWidth || "auto",
        }}
      />
    </div>
  );

  const renderCompanyBanner = data => (
    <div
      className={`__x __x_w ${data.text.color || "c12"}`}
      style={{
        background: data.bg.color || "#fff",
        color: data.banner.color || "#5d5c5c",
      }}
    >
      <div className="u-flex u-jcsb __x_t">
        <div className="__x_g">
          <div className="__x_wt">
            {data.banner.format === "html" ? (
              <ParseHTML html={data.banner.body} />
            ) : (
              data.banner.body
            )}
          </div>
          <div className="__x_ws">
            {data.subtitle.format === "html" ? (
              <ParseHTML html={data.subtitle.body} />
            ) : (
              data.subtitle.body
            )}
          </div>
        </div>
        {data.logo.src && (
          <div className="__x_wc">
            <img className="__x_wi u-width-100" src={data.logo.src} alt={data.logo.alt} />
          </div>
        )}
      </div>
    </div>
  );

  if (banner.imageBanner) return renderImageBanner(banner.imageBanner);
  if (banner.textBanner) return renderCompanyBanner(banner.textBanner);
  return null;
};

export default CompanyBanner;
